module.exports = __webpack_public_path__ + "static/media/image004.60f88e02.jpg";